import View from '../../view.js';

namespace('IO.Views.Components', function (exports) {
  'use strict';

  var IpField = View.extend({
    dom: {
      ADVANCED_SETTINGS: '.advanced-settings',
      ADVANCED_SETTINGS_ERRORS: '.advanced-settings .error',
      ADVANCED_SETTINGS_SHOW: '.show-advanced',
      ADVANCED_SETTINGS_VISIBLE_SHOW: '.show-advanced:visible',
      ADVANCED_SETTINGS_HIDE: '.hide-advanced',
      CHECKED_OCTET: '.octet:checked',
      MULTIPLE_VALUE_PROPERTY: '.multiple-value-property',
      MULTIPLE_VALUE_PROPERTY_BUTTON_ADD: '.multiple-value-button-add',
      MULTIPLE_VALUE_PROPERTY_BUTTON_REMOVE: '.multiple-value-button-remove',
      IP_PROPERTY_CONTAINER: '.ip-attribute-container',
      IP_PROPERTY_BUTTON_ADD: '.multiple-value-button-add.ip-attribute',
      IP_PROPERTY_TEMPLATE: '.ip-attribute-template',
      RADIOS_CUSTOM_INPUTS: '.radio',
      SELECT2_INITIALIZED: '.select2-container',
      SELECT2_NOT_INITIALIZED: '.select2select:not(.select2-hidden-accessible)',
      WITH_VALUE: '.with-value',
      SELECT_SEARCH: '.select2-input',
      IP_FIELD: 'select.ip-field',
      OCTETS: 'input[name*="ip_octet"]:not(.with-value), .octet',
      APPENDED_VALUE: 'input[name*="appended_value"]',
      IP_VALUE: 'select[name*="ip_address"]',
    },

    valid: true,

    events: function () {
      var self = this,
        events = {};

      $(this.el)
        .find(this.dom.IP_FIELD)
        .data('valid', true)
        .select2(
          select2Defaults({
            acceptNotFound: true,
            allowClear: true,
            placeholder: 'None',
          }),
        )
        .on('change', function (e) {
          self._validateFields(e);
        });

      events['click ' + this.dom.ADVANCED_SETTINGS_SHOW] = '_showAdvanced';
      events['click ' + this.dom.ADVANCED_SETTINGS_HIDE] = '_hideAdvanced';
      events['change ' + this.dom.OCTETS] = '_toogleWithField';
      if (this.options.multiple) {
        events['click ' + this.dom.IP_PROPERTY_BUTTON_ADD] = '_appendNewField';
        events['click ' + this.dom.MULTIPLE_VALUE_PROPERTY_BUTTON_REMOVE] =
          '_removeMultipleField';
      }
      return events;
    },

    initialize: function (options) {
      var self = this;

      if (options.limited && !options.multiple) {
        throw new Error(
          'Ip Field: You cannot initialize defining "limited" without "multiple: true"',
        );
      }

      this._ipCounter = this.$(this.dom.SELECT2_INITIALIZED).length;
      $(this.dom.OCTETS + ':eq(0)').trigger('change');

      this.$el.closest('form').on('submit', function () {
        self._attachedsEmpty();
        return !self._hasErrors();
      });
    },

    destroy: function () {
      this.off();
      this.remove();
    },

    _attachedsEmpty: function () {
      var self = this,
        attachedsNotEmpty,
        ipField = $(this.el).find(this.dom.IP_VALUE),
        attachedFields = [this.dom.APPENDED_VALUE, this.dom.WITH_VALUE];

      attachedsNotEmpty = _.some(attachedFields, function (i) {
        return !_.isEmpty($(self.el).find(i).val());
      });

      if (attachedsNotEmpty && _.isEmpty(ipField.val())) {
        this._sendError(
          'You must fill IP field to save any other IP data',
          ipField,
        );
      } else if (this._allValid()) {
        this._removeErrors(ipField);
      }
    },

    _allValid: function () {
      return _.every($(this.el).find(this.dom.IP_FIELD), function (el) {
        return $(el).data('valid');
      });
    },

    _toogleWithField: function (e) {
      var withValue = $(e.target)
          .parents('.advanced-settings')
          .find('.with-value'),
        octetValue = $(e.target)
          .parents('.first-line')
          .find('.octet:checked')
          .val();

      if (_.isEmpty(octetValue) || octetValue == 'na') {
        withValue.val('').attr('readonly', true);
      } else {
        withValue.attr('readonly', false);
      }
    },

    isValid: function () {
      var $form = this.$el.closest('form'),
        $advancedSettings = $form.find(this.dom.ADVANCED_SETTINGS),
        classes = 'field_with_errors has-tip-form error tip-right',
        errorMessage = "Can't be blank",
        $withValue,
        $checkedRadio,
        $radiosCustom,
        $el,
        noneOption,
        i;

      $form.find(this.dom.ADVANCED_SETTINGS_ERRORS).removeClass(classes);
      noneOption = 'na';
      for (i = $advancedSettings.length - 1; i >= 0; i--) {
        $el = $($advancedSettings[i]);
        $checkedRadio = $el.find(this.dom.CHECKED_OCTET);
        $radiosCustom = $el.find(this.dom.RADIOS_CUSTOM_INPUTS);
        $withValue = $el.find(this.dom.WITH_VALUE);

        if (
          !$withValue.val() &&
          $checkedRadio.val() &&
          $checkedRadio.val() !== noneOption
        ) {
          $withValue.addClass(classes).prop('title', errorMessage);
          $el
            .parent()
            .find(this.dom.ADVANCED_SETTINGS_VISIBLE_SHOW)
            .trigger('click');
        }

        if ($withValue.val() && !$checkedRadio.val()) {
          $radiosCustom.addClass('error field_with_errors');
          $el
            .parent()
            .find(this.dom.ADVANCED_SETTINGS_VISIBLE_SHOW)
            .trigger('click');
        }
      }

      return !$form.find(this.dom.ADVANCED_SETTINGS_ERRORS).length;
    },

    _appendNewField: function (e) {
      var $button = $(e.currentTarget),
        $property = $button.closest(this.dom.MULTIPLE_VALUE_PROPERTY),
        numberInputs;

      this._appendTemplate($property);
      $button.css('bottom', '0').css('top', 'auto');

      numberInputs = $property.find(this.dom.IP_PROPERTY_CONTAINER).length;
      if (
        this.options.limited &&
        this._isLimited($button.data('input')) &&
        this._reachedLimit($button.data('input'), numberInputs)
      ) {
        $button.hide();
        $property
          .find(this.dom.MULTIPLE_VALUE_PROPERTY_BUTTON_REMOVE)
          .last()
          .show();
      }

      return false;
    },

    _appendTemplate: function ($property) {
      var attrCounter = $property.data('counter'),
        tmpl = _.template($property.find(this.dom.IP_PROPERTY_TEMPLATE).text())(
          {
            attr_counter: attrCounter, // eslint-disable-line camelcase
            ip_counter: this._ipCounter, // eslint-disable-line camelcase
          },
        );

      // maybe use first property container clone instead of template (problem: attr_counter and ip_counter)
      $property.append(tmpl);
      this._ipCounter++;
      this.trigger(
        'before:select2',
        $property.find(this.dom.SELECT2_NOT_INITIALIZED),
      );
      $property.find(this.dom.SELECT2_NOT_INITIALIZED).select2(
        select2Defaults({
          acceptNotFound: true,
          allowClear: true,
          placeholder: 'None',
        }),
      );
      this.trigger('after:select2');
    },

    _removeMultipleField: function (e) {
      var $target = $(e.currentTarget),
        $multipleProperty = $target.closest(this.dom.MULTIPLE_VALUE_PROPERTY),
        numberInputs = $multipleProperty.find(
          this.dom.IP_PROPERTY_CONTAINER,
        ).length;

      if (
        this.options.limited &&
        this._isLimited($target.data('input')) &&
        this._reachedLimit($target.data('input'), numberInputs)
      ) {
        $multipleProperty
          .find(this.dom.MULTIPLE_VALUE_PROPERTY_BUTTON_ADD)
          .show();
      }

      $target.closest('div').remove();
      return false;
    },

    _lastAdvancedSettingsOpened: function ($property) {
      return $property.hasClass('opened');
    },

    _showAdvanced: function (e) {
      var $this = $(e.currentTarget),
        $ipProperty = $this.closest(this.dom.IP_PROPERTY_CONTAINER),
        $multipleValuePropertyContainer = $ipProperty.closest(
          this.dom.MULTIPLE_VALUE_PROPERTY,
        ),
        $lastProperty = $multipleValuePropertyContainer.children().last(),
        $button;

      e.preventDefault();
      $ipProperty.addClass('opened');

      if (this._lastAdvancedSettingsOpened($lastProperty)) {
        $button = $multipleValuePropertyContainer.find(
          this.dom.MULTIPLE_VALUE_PROPERTY_BUTTON_ADD,
        );
        $button.animate({ bottom: 106 }, 400);
      }

      $ipProperty.find(this.dom.ADVANCED_SETTINGS).stop().slideToggle();
    },

    _hideAdvanced: function (e) {
      var $this = $(e.currentTarget),
        $ipProperty = $this.closest(this.dom.IP_PROPERTY_CONTAINER),
        $multipleValuePropertyContainer = $ipProperty.closest(
          this.dom.MULTIPLE_VALUE_PROPERTY,
        ),
        $lastProperty = $multipleValuePropertyContainer.children().last(),
        $button;

      e.preventDefault();
      $ipProperty.find(this.dom.ADVANCED_SETTINGS).stop().slideToggle();
      $ipProperty.removeClass('opened');
      if (!this._lastAdvancedSettingsOpened($lastProperty)) {
        $button = $multipleValuePropertyContainer.find(
          this.dom.MULTIPLE_VALUE_PROPERTY_BUTTON_ADD,
        );
        $button.animate({ bottom: 5 }, 400);
      }
    },

    _validOctets: function (value) {
      var validOctets = true;

      value.split('.').forEach(function (el) {
        var octet = parseInt(el);

        if (octet < 0 || octet > 255) {
          validOctets = false;
        }
      });
      return validOctets;
    },

    _validateFields: function (e) {
      var self = this,
        element = $(e.target),
        val = element.val(),
        removeErrors = function () {
          element.data('valid', true);
          if (self._allValid()) {
            self._removeErrors(element);
          }
        },
        allowedOptions,
        validIp = /^(?:\d{1,3}\.){3}\d{1,3}$/,
        validIpOrRpmVariable = /^(my_|(\d{1,3}.){3})(\d{1,3}|\w+)$/,
        validNumberOrRpmVariable = /^(my_\w+|\d+)$/,
        octetSize = 4;

      if (val == '') {
        removeErrors();
        return;
      }

      try {
        if (!element.hasClass('ip-appendix')) {
          allowedOptions = JSON.parse(
            $('input[name="validate[ip_address]"]').val(),
          );
        }

        if (element.hasClass('ip-appendix')) {
          allowedOptions = JSON.parse(
            $('input[name="validate[ip_appendix]"]').val(),
          );
        }

        if (
          !element.hasClass('ip-appendix') &&
          allowedOptions.indexOf(val) == -1
        ) {
          if (element.hasClass('ip-strict')) {
            if (!val.match(validIp)) {
              throw new Error('Only IPs addresses will be accepted.');
            }

            if (val.split('.').length !== octetSize) {
              throw new Error('Only 4 octets will be accepted.');
            }

            if (self._validOctets(val) === false) {
              throw new Error(
                'Octets will be by accepted if they are between 0 and 255.',
              );
            }
          } else if (!val.match(validIpOrRpmVariable)) {
            throw new Error(
              'Only IPs addresses or variables will be accepted.',
            );
          }
        } else if (
          element.hasClass('ip-appendix') &&
          allowedOptions.indexOf(val) == -1
        ) {
          // eslint-disable-line curly
          if (
            !(val == parseInt(val, 10)) &&
            element.hasClass('number-strict')
          ) {
            throw new Error('Only numbers are allowed.');
          } else if (!val.match(validNumberOrRpmVariable)) {
            throw new Error('Only numbers or variables are allowed.');
          }
        }

        removeErrors();
      } catch (error) {
        element.data('valid', false);
        self._sendError(error.message, element);
      }
    },

    _hasErrors: function () {
      return $(this.el).find('small.error').length > 0;
    },

    _removeErrors: function (element) {
      element.removeClass('field_with_errors');
      element.closest('td').find('small.error').remove();
    },

    _sendError: function (message, element) {
      var errorContainer = element.closest('td').find('small.error');

      element.addClass('field_with_errors');
      if (errorContainer.length > 0) {
        errorContainer.text(message);
      } else {
        element
          .closest('td')
          .append('<small class="error">' + message + '</small>');
      }
    },

    _isLimited: function (input) {
      return _.contains(_.keys(this.options.limited), input);
    },

    _reachedLimit: function (input, number) {
      return number === this.options.limited[input];
    },
  });

  exports.IpField = IpField;
});
